import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../api";
import urls from "../urls";
import type { GeneratorOverview } from "../utils/backend-types";

export const generatorQueries = {
  detail: (generatorId?: number) =>
    queryOptions({
      queryKey: ["generators", { generatorId }],
      queryFn:
        typeof generatorId !== "undefined"
          ? () => fetchGenerator(generatorId)
          : skipToken,
      enabled: typeof generatorId !== "undefined",
      refetchInterval: false,
      refetchOnWindowFocus: false,
      ...queryOptions
    })
};

function useGenerator(id: number) {
  return useQuery(generatorQueries.detail(id));
}

async function fetchGenerator(id: number) {
  const response = await apiWithoutCamelization.get<GeneratorOverview>(
    urls.api.generator(id)
  );
  return response.data;
}

export { useGenerator };
